module.exports = __webpack_public_path__ + "img/identity-black-c.842dc636.svg";